<ng-container *ngIf="!useCarousels; else oldHeader">
  <div class="l_flexbar guts-m-b-2" [class.m-l_flexbar-col]="showReorderButton">
    <div
      class="guts-p-full-0"
      [ngClass]="
        isEditing || isReordering ? 'grid__col-8  m-full-width' : 'grid__col-12'
      "
    >
      <ng-container *ngIf="!showQuickEditHeader; else quickEditHeader">
        <h2 class="h2 guts-p-b-1 break">{{ headerText }}</h2>
        <div *ngIf="markdownDescription" class="full-width">
          <div
            class="markdown par par--small break"
            [innerHTML]="
              markdownDescription | markdownToHtml: { allowImages: true }
            "
          ></div>
          <span>
            <!-- Placeholder for metadata: items and duration etc -->
          </span>
        </div>
      </ng-container>
      <ng-template #quickEditHeader>
        <form
          role="form"
          [formGroup]="form"
          class="form-wrap full-width guts-m-t-1--negative"
        >
          <df-form-root
            [form]="form"
            [fields]="fields"
            [model]="model"
            [options]="options"
          ></df-form-root>
        </form>
      </ng-template>
    </div>
    <div
      *ngIf="isEditing || isReordering"
      class="l_flex-row l_flex-top l_flex-justify-right grid__col-4 guts-m-l-1 guts-p-full-0"
      [ngClass]="
        showReorderButton ? 'm-guts-m-l-0 m-guts-m-t-1 m-full-width' : ''
      "
    >
      <button
        *ngIf="isEditing && showReorderButton"
        df-button
        dfButtonType="primary"
        class="flex-row-header__button no-wrap guts-m-r-half"
        [class.bg-color-ebony-a08]="!isReordering"
        [class.color-ebony]="!isReordering"
        [class.color-white]="isReordering && !row.loading"
        [class.bg-color-blue]="isReordering && !row.loading"
        [disabled]="row.loading"
        data-dgat="flex-row-header-bb4"
        (click)="toggleReorder()"
      >
        {{ isReordering ? i18n.Core_Done : i18n.dgFlexRow_ReorderItems }}
      </button>
      <button
        *ngIf="isEditing && menuConfig.length"
        (click)="menuConfig[0].defaultAction($event)"
        df-button
        df-button-square
        dfButtonType="primary"
        [ngbTooltip]="'dgFlexRow_EditSectionDetails' | translate"
        [attr.aria-label]="'dgFlexRow_EditSectionDetails' | translate"
        class="flex-row-header__button flex-row-header__button--square bg-color-ebony-a08"
        data-dgat="flex-row-header-f8d"
      >
        <df-icon icon="gear" class="color-ebony"></df-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #oldHeader>
  <div class="guts-m-b-1 l_flexbar m-l_flexbar-col">
    <div class="full-width">
      <div class="l_flex">
        <h2 class="h3 guts-p-r-half break">{{ headerText }}</h2>
        <dgx-skill-standards-segment-status-indicator-intermediary
          *ngIf="row.flexRowType === 'SkillStandardsSegment'"
          class="guts-p-l-half"
        ></dgx-skill-standards-segment-status-indicator-intermediary>
        <dgx-menu
          *ngIf="isEditing && menuConfig.length"
          [menuConfig]="menuConfig"
          placement="bottom-left"
          [appendToBody]="false"
          [placementAdjustLeftRem]="0.5"
        >
          <button
            df-button
            dfButtonType="clear"
            [attr.aria-label]="'dgFlexRow_EditSectionDetails' | translate"
            data-dgat="sectionHead-751"
            class="content-card__menu guts-p-v-quart guts-p-h-half rounded--large"
          >
            <df-icon icon="dots"></df-icon></button
        ></dgx-menu>
      </div>
      <div
        *ngIf="markdownDescription"
        class="markdown full-width break"
        [innerHTML]="
          markdownDescription | markdownToHtml: { allowImages: true }
        "
      ></div>
    </div>

    <dgx-link-row
      *ngIf="!!links?.length && !hideLinks"
      [links]="links"
      class="l_flex l_flex-justify-right guts-p-t-half"
    ></dgx-link-row>
  </div>
</ng-template>
